/** Kleine Mathe-Helfer fuer die 2D-Simulationsebene. */

import type { Vec2 } from './types.js';

/** Begrenzt einen Wert auf den Bereich [min, max]. */
export function clamp(value: number, min: number, max: number): number {
  return value < min ? min : value > max ? max : value;
}

/** Lineare Interpolation zwischen a und b. t wird auf [0,1] begrenzt. */
export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * clamp(t, 0, 1);
}

/** Quadrierte Distanz - schneller als distance(), ausreichend fuer Reichweitenvergleiche. */
export function distanceSquared(a: Vec2, b: Vec2): number {
  const dx = a.x - b.x;
  const dy = a.y - b.y;
  return dx * dx + dy * dy;
}

/** Echte Distanz zwischen zwei Punkten. */
export function distance(a: Vec2, b: Vec2): number {
  return Math.sqrt(distanceSquared(a, b));
}

/** Prueft, ob b innerhalb von "range" um a liegt. */
export function isWithinRange(a: Vec2, b: Vec2, range: number): boolean {
  return distanceSquared(a, b) <= range * range;
}
